import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore, useItemsStore, useSessionStore, useSitesStore } from "@/stores";
import type IStockDemand from "@/models/responses/IStockDemand";
import StockDemand from "@/models/frontend/StockDemand";

export const useStockDemandStore = defineStore("stockDemand", {
  state: () => ({
    error: "" as any,
    data: [] as StockDemand[],
  }),
  actions: {
    async fetchAll(showAll: boolean) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      const sessionStore = useSessionStore();
      const { selectedSiteId } = storeToRefs(sessionStore);

      this.error = "";
      let url = "v1.0/stock-demand";
      if (selectedSiteId.value > 0) {
        url = "v1.0/stock-demand?siteId=" + selectedSiteId.value;
      }
      await api
        .get<IStockDemand[]>(url, { params: { showAll: showAll }})
        .then((response) => (this.data = response.data.map(x => this.mapToFrontend(x))))
        .catch((error) => (this.error = error));
    },
    mapToFrontend(stockDemand: IStockDemand) {
      const sitesStore = useSitesStore();
      const itemsStore = useItemsStore();
      const site = sitesStore.getById(stockDemand.siteId);
      const item = itemsStore.getById(stockDemand.itemId);
      return new StockDemand(
        site,
        item,
        stockDemand.quantity,
        stockDemand.minQuantity,
        stockDemand.maxQuantity,
        stockDemand.orderedQuantity,
        stockDemand.deliveredQuantity,
        stockDemand.stockQuantity,
        stockDemand.stockLevelId,
        stockDemand.minQuantityBreachedAt,
        stockDemand.maxQuantityReachedAt,
      );
    },
  },
});
